'use client'

import React, { createContext, useContext, useState } from 'react'
import localStorage from '@locmod/local-storage'
import { constants } from 'helpers'
import { formatViewValue } from 'src/utils/helper'

export enum OddsView {
  Fractional = 'fractional',
  DecimalWith2Decimals = 'decimalWith2Decimals',
  Moneyline = 'moneyline',
  DecimalWith3Decimals = 'decimalWith3Decimals',
  DecimalWith5Decimals = 'decimalWith5Decimals',
}

export const oddsViews = {
  [OddsView.Fractional]: 'UK Odds (1/2)',
  [OddsView.Moneyline]: 'US Odds (-200)',
  [OddsView.DecimalWith2Decimals]: 'EU Odds (1.50)',
  [OddsView.DecimalWith3Decimals]: 'EU Odds (1.500)',
  [OddsView.DecimalWith5Decimals]: 'EU Odds (1.50000)',
}

const values = Object.keys(oddsViews)

type Context = {
  oddsView: OddsView
  setOddsView: (oddView: OddsView) => void
  formatViewValue: (value: string | number) => string
}

const Context = createContext<Context>(null as any)

export const useOddsView = () => {
  return useContext(Context)
}

export const OddsViewProvider: React.CFC = ({ children }) => {
  let initialValue = localStorage.getItem(
    constants.localStorageKeys.oddsView
  ) as OddsView

  if (!initialValue || !values.includes(initialValue)) {
    initialValue = OddsView.DecimalWith2Decimals
  }

  const [oddsView, setActiveOddsView] = useState<OddsView>(initialValue)

  const setOddsView = (value: OddsView) => {
    localStorage.setItem(constants.localStorageKeys.oddsView, value)
    setActiveOddsView(value)
  }

  const context: Context = {
    oddsView,
    setOddsView,
    formatViewValue: value => formatViewValue(oddsView, value),
  }

  return <Context.Provider value={context}>{children}</Context.Provider>
}
